import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { showToast } from "../../../../components/custom/custom-toast";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { IconCheckSuccess, IconReset } from "../../../../components/icons/icon-group";
import { STATUS } from "../../../../constants/status";
import { useFetchData } from "../../../../hooks/useFetch";
import { EmployeeResponse } from "../../../../models/response/employee";
import { API_ADMIN_ROUTER } from "../../../../services/api-config";

interface AdminChangeStatusProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  dataObject: EmployeeResponse;
  setChangeStatus?: (value: boolean) => void;
  type?: number;
  setIsOpenInfo?: (value: boolean) => void;
  setDataObject?: (value: EmployeeResponse) => void;
  setRefresh?: (value: boolean) => void;
}

export const AdminChangeStatus = ({
  isOpen,
  setIsOpen,
  dataObject,
  setChangeStatus = () => {},
  type = STATUS.ALL,
  setIsOpenInfo = () => {},
  setDataObject = () => {},
  setRefresh = () => {},
}: AdminChangeStatusProps) => {
  const dispatch = useDispatch();

  const { request: fetchDataChangeStatus, baseResponse: responsesChangeStatus } = useFetchData.Post();

  const { request: fetchDataResetPass, baseResponse: responsesResetPass } = useFetchData.Post();

  const handleChangeStatus = () => {
    if (!isOpen) return;
    fetchDataChangeStatus({
      endPoint: API_ADMIN_ROUTER.API_CHANGE_STATUS_ADMIN(dataObject._id),
      data: {
        status: dataObject.status === STATUS.ACTIVE ? STATUS.INACTIVE : STATUS.ACTIVE,
      },
    });
  };

  useEffect(() => {
    if (!responsesChangeStatus) return;
    if (responsesChangeStatus.status === 200) {
      setIsOpen(false);
      setChangeStatus(true);
      showToast({ message: "Đổi trạng thái thành công!", type: "success" });
      setRefresh(true);
    }
  }, [responsesChangeStatus, dispatch, setChangeStatus, setIsOpen]);

  const handleResetPass = () => {
    if (!isOpen) return;
    fetchDataResetPass({
      endPoint: API_ADMIN_ROUTER.API_RESET_PASSWORD_ADMIN(dataObject._id),
    });
  };
  useEffect(() => {
    if (!responsesResetPass) return;
    if (responsesResetPass.status === 200) {
      showToast({
        message: "Reset mật khẩu nhân viên thành công",
        type: "success",
      });
      setDataObject(responsesResetPass.data as EmployeeResponse);
      setIsOpenInfo(true);
      setIsOpen(false);
    }
  }, [responsesResetPass, setDataObject, setIsOpenInfo, setIsOpen]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col justify-center items-center">
        {type === STATUS.ALL ? (
          <>
            <IconCheckSuccess className="w-16 h-16 mb-3" />
            {dataObject.status === STATUS.ACTIVE ? (
              <label htmlFor="name" className="text-center">
                Bạn có muốn Tạm ngưng hoạt động của admin
                <span className="text-blue-600 uppercase"> {dataObject.name} </span>
                không?
              </label>
            ) : (
              <label htmlFor="name" className="text-center">
                Bạn có muốn Bật hoạt động của admin
                <span className="text-blue-600 uppercase"> {dataObject.name} </span>
                không?
              </label>
            )}
          </>
        ) : (
          <>
            <IconReset className="w-16 h-16 mb-3" />
            <label htmlFor="name" className="text-center">
              Bạn có muốn reset mật khẩu của admin
              <span className="text-blue-600 uppercase"> {dataObject.name} </span>
              không?
            </label>
          </>
        )}
      </div>
    );
  };
  const footerModal = () => {
    return (
      <>
        <ButtonCustom
          type="button"
          text="Đóng"
          onClick={() => {
            setIsOpen(false);
          }}
          className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
        />
        <ButtonCustom
          type="button"
          text="Đồng ý"
          onClick={() => {
            type === STATUS.ALL ? handleChangeStatus() : handleResetPass();
          }}
        />
      </>
    );
  };

  return (
    <ModalCustom
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      titleModal="Thông báo"
      bodyModal={bodyModal()}
      footerModal={footerModal()}
      modalSize="50%"
    />
  );
};
